import { useEffect, useState } from "preact/hooks";
import register from "preact-custom-element";

import dayjs from "dayjs";

interface CountdownProps {
  targetValue: string;
}

interface PendingTime {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const calculatePendingTime = (target: string): PendingTime => {
  const targetTime = dayjs(target);

  if (!targetTime) {
    throw new Error("Invalid target date");
  }

  const now = dayjs();
  let delta = targetTime.diff(now) / 1000;

  const days = Math.floor(delta / 86400);
  delta -= days * 86400;

  const hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;

  const minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;

  const seconds = Math.floor(delta % 60);

  return {
    days,
    hours,
    minutes,
    seconds,
  };
};

const CountdownElement = ({ value, unit }: { value: number; unit: string }) => {
  return (
    <div class="flex flex-col">
      <span class="countdown font-mono text-5xl">
        <span
          style={{
            "--value": value,
            "--digits": 2,
          } as preact.CSSProperties}
          aria-live="polite"
          aria-label={`${value} ${unit}`}
        >
          {value}
        </span>
      </span>
      <span class="font-bold font-[Leonetta-Serif]">
        {unit}
      </span>
    </div>
  );
};

const Countdown = ({ targetValue = "2026-09-04 18:00" }: CountdownProps) => {
  const [pendingTime, setPendingTime] = useState<PendingTime>(
    calculatePendingTime(targetValue),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setPendingTime(calculatePendingTime(targetValue));
    }, 10);

    return () => clearInterval(interval);
  }, []);

  return (
    <div class="flex justify-center">
      <div class="grid grid-flow-col gap-5 text-center auto-cols-max max-auto">
        <CountdownElement value={pendingTime.days} unit="days" />
        <CountdownElement value={pendingTime.hours} unit="hours" />
        <CountdownElement value={pendingTime.minutes} unit="min" />
        <CountdownElement value={pendingTime.seconds} unit="sec" />
      </div>
    </div>
  );
};

register(Countdown, "wedding-countdown", ["targetValue"]);
